import { useMutation, useQuery } from "@tanstack/react-query";
import { studyApiService } from "api/modules/studymodule.api";
import { StudyFilterFormValues } from "modules/Study/Study/components/StudyFilter";
import { StudyFormValues } from "modules/Study/Study/helpers/study.types";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

// ------------------------------------------------------------------
//-- Study
// ------------------------------------------------------------------

export const useStudyDetailsService = (
  searchText?: string | null,
  isdraft?: boolean | null | undefined,
  id?: number,
  filters?: StudyFilterFormValues | null,
  pageNumber: number = 1,
  pageSize: number = 10,
  studystatus?: string | null
) => {
  const SelectAllQuery = useQuery({
    queryKey: [
      "study-selectAll",
      isdraft,
      searchText,
      filters,
      pageNumber,
      pageSize,
      studystatus
    ],
    queryFn: () =>
      studyApiService.getSelectAllData(
        isdraft,
        searchText,
        filters,
        pageNumber,
        pageSize,
        studystatus
      ),
    enabled: !id,
  });

  const SelectQuery = useQuery({
    queryKey: ["study-select", id],
    queryFn: () => studyApiService.getSelectData(id!),
    enabled: !!id,
  });

  const InsertMutation = useMutation<ApiResponse, Error, StudyFormValues>({
    mutationFn: (payload: StudyFormValues) =>
      studyApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, StudyFormValues>({
    mutationFn: (payload: StudyFormValues) =>
      studyApiService.updateData(payload),
  });

  const DeleteMutation = useMutation<
    ApiResponse,
    Error,
    { id: number; updatereason: string }
  >({
    mutationFn: (payload) =>
      studyApiService.deleteData({
        id: payload.id,
        updatereason: payload.updatereason,
      }),
  });

  return {
    SelectAllQuery,
    SelectQuery,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
  };
};




